<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import DateUtil from '@/utils/IM/tradeDataUtil'
  import Url from '@/views/crs/util/url'
  import Qs from 'qs'
  const task = {
      1: window.$t('crs.active.task1'),
      3: window.$t('crs.active.task3'),
      4: window.$t('crs.active.task4'),
      5: window.$t('crs.active.task5'),
      6: window.$t('crs.active.task6'),
      7: window.$t('crs.active.task7'),
      8: window.$t('crs.active.task8'),
      9: window.$t('crs.active.task9'),
      10: window.$t('crs.active.task10'),
  };
  const customerStatus = {
      A:"已激活",
      S:"冻结",
      D:"销户",
      BL:"黑名单",
      N:"未激活"
  };
  const status = {0:"未完成",1:"已完成(待领取)",2:"已领取"};
  export default {
    name: 'activeuser',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t('crs.bt.search') == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(data);
        }else if (clickName == window.$t('crs.bt.edit')){
          this.$refs.childUpdate.open();
        }else if("导出" == clickName || window.$t('crs.bt.export') == clickName){
            var exportURL = Url.active.user.export
            var qs = require('qs');
            this.$axios.post(exportURL, qs.stringify(data),{responseType:'blob'
            }).then(function (response) {
              const url = URL.createObjectURL(new Blob([response], {type: 'application/vnd.ms-excel'}))
              const link = document.createElement('a')
              link.href = url
              link.setAttribute('download', '活动参与用户')
              document.body.appendChild(link)
              link.click()
            }).catch(function (error) {
              console.log(error);
            });
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(Url.active.user.edit ,model,res => {
            this.$refs.childTable.defaultGetData(this.queryData);
            if (res.code == 0){
                this.$refs.childUpdate.close();
                this.$message.success("suc");
            }else{
                this.$message.error(res.message);
            }
      })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
              { title: window.$t('crs.active.customerNo'), field: 'customerNo'},
              { title: window.$t('crs.active.task'), field: 'task',type:2,optionList:task},
              { title: window.$t('crs.common.status'), field: 'status',type:2,optionList:status},
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: window.$t('crs.active.customerNo'), field: 'customerNo'},
              { title: window.$t('crs.active.activeNo'), field: 'activeNo'},
              { title: window.$t('crs.active.activeName'), field: 'activeName'},
              { title: window.$t('crs.common.phone'), field: 'phone'},
              { title: window.$t('crs.common.status'), field: 'customerStatus', type:2,optionList:customerStatus},
              { title: window.$t('crs.active.startTime'), type:5, field: 'startTime'},
              { title: window.$t('crs.active.endTime'), type:5, field: 'endTime'},
              { title: window.$t('crs.active.customerCreateStartTime'), type:5, field: 'customerCreateStartTime'},
              { title: window.$t('crs.active.customerCreateEndTime'), type:5, field: 'customerCreateEndTime'},
              { title: window.$t('crs.active.customerActivatedStartTime'), type:5, field: 'customerActivatedStartTime'},
              { title: window.$t('crs.active.customerActivatedEndTime'), type:5, field: 'customerActivatedEndTime'},
              {click: window.$t('crs.bt.search')},
              {click: window.$t('crs.bt.edit')},
              {click: window.$t('crs.bt.export')},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: Url.active.user.qurey, //请求路径和参数
          sequence: true,
          cols: [
              { title: window.$t('crs.active.customerNo'), field: 'customerNo'},
              { title: window.$t('crs.active.activeNo'), field: 'activeNo'},
              { title: window.$t('crs.active.startTime'), field: 'startTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('crs.active.endTime'), field: 'endTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('crs.active.activeName'), field: 'activeName'},
              { title: window.$t('crs.active.chineseName'), field: 'chineseName'},
              { title: window.$t('crs.common.phone'), field: 'phone'},
              { title: window.$t('crs.active.task1'), field: 'task1',render:(data,full)=>{
                      return status[data];
                  }},
              { title: window.$t('crs.active.task3'), field: 'task3',render:(data,full)=>{
                      return status[data];
                  }},
              { title: window.$t('crs.active.task4'), field: 'task4',render:(data,full)=>{
                      return status[data];
                  }},
              { title: window.$t('crs.active.task5'), field: 'task5',render:(data,full)=>{
                      return status[data];
                  }},
              { title: window.$t('crs.active.task6'), field: 'task6',render:(data,full)=>{
                      return status[data];
                  }},
              { title: window.$t('crs.active.task7'), field: 'task7',render:(data,full)=>{
                      return status[data];
                  }},
              { title: window.$t('crs.active.task8'), field: 'task8',render:(data,full)=>{
                      return status[data];
                  }},
              { title: window.$t('crs.active.task9'), field: 'task9',render:(data,full)=>{
                      return status[data];
                  }},
              { title: window.$t('crs.active.task10'), field: 'task10',render:(data,full)=>{
                      return status[data];
                  }},
              { title: window.$t('crs.active.customerCreateTime'), field: 'customerCreateTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('crs.active.customerActivatedTime'), field: 'customerActivatedTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('crs.active.customerStatus'), field: 'customerStatus'},
              { title: window.$t('crs.active.amount'), field: 'amount'},
              { title: window.$t('crs.active.amountCny'), field: 'amountCny'},
              { title: window.$t('crs.common.createTime'), field: 'createTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }},
              { title: window.$t('crs.common.updateTime'), field: 'updateTime',render:(data,full)=>{
                      return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                  }}
          ]
        }
      }
    }
  }
</script>
